import PositionForm from "./PositionForm";

const emptyPosition = {
  StrategyType: "",
  Strategy1: "",
  Symbol: "",
  Alias2: "",
  Start: "",
  Local: "USD",
  SecType: "",
  StartPrc: "",
  Ticker_Exchange_Code: "",
  BB_Ticker_Code: "",
  Price_Multiplier: "",
  Position_Multiplier: "",
  sec_type2: "",
};

export default function CreatePositions() {
  return <PositionForm initialData={emptyPosition} mode="create" />;
}
